<template>
  <div v-if="onlineIssuingAvailable" class="online-issuing-wrapper">
    <h1>{{$t('onlineIssuing.heading')}}</h1>
    <p class="info">
      {{$t('onlineIssuing.info')}}
    </p>
    <a class="online-button" :href="onlineIssuing.url" aria-label="order" target=”_blank”>
      {{$t('onlineIssuing.button')}}
      <shopping-cart-icon icon-class="icon" />
    </a>
  </div>
</template>

<style scoped>
  .online-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: white;
    font-weight: 500;
    border-radius: 4px;
    background-color: #40b8b8;
    padding: 8px 16px;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    max-width: 120px;
  }

  .icon {
    margin-left: 12px;
  }

</style>

<script>
import OmClient from '@/http/OmClient';
import { mapState, mapGetters } from 'vuex';
import ShoppingCartIcon from './icons/ShoppingCartIcon.vue';

export default {
  name: 'online-issuing',
  created() {
    this.$root.$on('country-change', this.handleCountryChange);
  },
  data() {
    return {
      omClient: new OmClient(this.getBearerToken()),
    };
  },
  computed: {
    ...mapState({
      onlineIssuing: (state) => state.pos.onlineIssuing,
    }),
    onlineIssuingAvailable() {
      return !!this.onlineIssuing;
    },
  },
  methods: {
    ...mapGetters({
      getBearerToken: 'getBearerToken',
    }),
    handleCountryChange(e) {
      this.omClient.fetchOnlineIssuing(e);
    },
  },
  components: {
    ShoppingCartIcon,
  },
};
</script>
